import React from 'react';
import { Grid, Typography, Tooltip } from '@material-ui/core';
import { AiOutlineDownload } from 'react-icons/ai';
import ReactToPrint from 'react-to-print';
import { timeout } from '../utils';

const DELIVERIES = [1, 2, 3];

const deliveryTabStyle = isActive => ({
  fontWeight: isActive && 600,
  cursor: 'pointer',
  paddingBottom: 2,
  borderBottom: isActive ? '2px solid #000' : '2px solid #FFF',
});

export default function Toolbar({
  selectedDelivery,
  onSelectDelivery,
  styleCollection,
  hasProducts,
  onStartNotes,
  printRef,
  onBeforePrint,
  onAfterPrint,
}) {
  return (
    <Grid>
      <Grid
        style={{ marginTop: 10 }}
        container
        justifyContent="space-between"
        wrap="nowrap"
      >
        <Grid container alignItems="center" style={{ width: 200 }}>
          <Tooltip title="Use 'Save as PDF' mode">
            <Grid>
              <ReactToPrint
                trigger={() => (
                  <Grid
                    container
                    alignItems="center"
                    style={{
                      cursor: 'pointer',
                      gap: 6,
                      padding: '6px 12px',
                      border: '1px solid #000',
                      width: 'fit-content',
                    }}
                    onClick={onBeforePrint}
                  >
                    <AiOutlineDownload size={16} color="black" />
                    <Typography style={{ fontSize: 12, lineHeight: 1 }}>
                      Download PDF
                    </Typography>
                  </Grid>
                )}
                content={() => printRef.current}
                onAfterPrint={onAfterPrint}
                onBeforeGetContent={async () => {
                  onBeforePrint();
                  await timeout(1000);
                }}
              />
            </Grid>
          </Tooltip>
        </Grid>
        <Grid
          container
          style={{ width: '60%' }}
          justifyContent={
            styleCollection === 'SWIMWEAR' ? 'space-evenly' : 'space-around'
          }
        >
          {DELIVERIES.map(deliveryNumber => (
            <Grid key={deliveryNumber}>
              <Typography
                onClick={() => onSelectDelivery(deliveryNumber)}
                style={deliveryTabStyle(selectedDelivery === deliveryNumber)}
              >
                Delivery {deliveryNumber}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <Grid
          style={{
            cursor: 'pointer',
            backgroundColor: hasProducts ? 'black' : '#808080',
            padding: '8px 40px',
            marginRight: '1%',
          }}
          onClick={onStartNotes}
        >
          <Typography style={{ color: '#FFFFFF' }}>Start Notes</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
